export function blockInteraction(state) {
  state.canInteract = false;
}

export function allowInteraction(state) {
  state.canInteract = true;
}
